import { render } from "./RightChevronIcon.vue?vue&type=template&id=d3112ff0&scoped=true"
import script from "./RightChevronIcon.vue?vue&type=script&lang=js"
export * from "./RightChevronIcon.vue?vue&type=script&lang=js"

import "./RightChevronIcon.vue?vue&type=style&index=0&id=d3112ff0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d3112ff0"

export default script